"use strict";
exports.__esModule = true;
exports.IS_IMAGE_FILE_EXTENSION_REGEX = exports.IS_IMAGE_URI_REGEX = exports.base64UriValidationRegex = exports.emailAddressValidationRegex = void 0;
exports.emailAddressValidationRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
exports.base64UriValidationRegex = /^data:image\/[a-zA-Z]+;base64,[A-Za-z0-9+\/_-]*(={0,2})?$/;
exports.IS_IMAGE_URI_REGEX = /^data:image\/(png|jpg|jpeg|bmp|gif|webp);base64,/;
exports.IS_IMAGE_FILE_EXTENSION_REGEX = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
